var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminKyc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_101_1147)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8521,
    r: 20,
    fill: "url(#paint0_linear_101_1147)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8521,
    r: 20,
    fill: "url(#paint1_linear_101_1147)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8521,
    r: 17.5,
    stroke: "url(#paint2_linear_101_1147)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8521,
    r: 17.5,
    stroke: "url(#paint3_linear_101_1147)",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5281 13.5074C31.3395 13.3417 31.0929 13.2577 30.8423 13.2737C30.5918 13.2897 30.3578 13.4044 30.1918 13.5927L28.4196 15.6303L27.8225 14.9574C27.6554 14.7689 27.4202 14.6545 27.1687 14.6394C26.9172 14.6243 26.67 14.7097 26.4815 14.8768C26.293 15.044 26.1786 15.2792 26.1635 15.5307C26.1484 15.7822 26.2338 16.0294 26.401 16.2179L27.7183 17.6963C27.808 17.7957 27.9177 17.8749 28.0402 17.9288C28.1627 17.9827 28.2952 18.0101 28.4291 18.009C28.562 18.0075 28.6932 17.9781 28.814 17.9226C28.9348 17.867 29.0426 17.7867 29.1304 17.6868L31.6039 14.8437C31.7707 14.6563 31.8564 14.4104 31.8422 14.1599C31.828 13.9094 31.715 13.6747 31.5281 13.5074ZM20.4778 19.9045C21.2275 19.9045 21.9604 19.6821 22.5838 19.2656C23.2072 18.8491 23.6931 18.257 23.98 17.5643C24.267 16.8716 24.342 16.1094 24.1958 15.3741C24.0495 14.6387 23.6885 13.9632 23.1583 13.4331C22.6281 12.9029 21.9527 12.5419 21.2173 12.3956C20.482 12.2493 19.7197 12.3244 19.0271 12.6113C18.3344 12.8982 17.7423 13.3841 17.3258 14.0075C16.9092 14.6309 16.6869 15.3639 16.6869 16.1136C16.6869 17.119 17.0863 18.0832 17.7972 18.7942C18.5081 19.5051 19.4724 19.9045 20.4778 19.9045ZM20.4778 14.2182C20.8526 14.2182 21.2191 14.3293 21.5308 14.5376C21.8425 14.7459 22.0854 15.0419 22.2289 15.3883C22.3724 15.7346 22.4099 16.1157 22.3368 16.4834C22.2636 16.8511 22.0831 17.1888 21.818 17.4539C21.5529 17.719 21.2152 17.8995 20.8475 17.9726C20.4799 18.0458 20.0987 18.0082 19.7524 17.8648C19.4061 17.7213 19.11 17.4784 18.9018 17.1667C18.6935 16.855 18.5823 16.4885 18.5823 16.1136C18.5823 15.6109 18.782 15.1288 19.1375 14.7733C19.4929 14.4179 19.9751 14.2182 20.4778 14.2182ZM20.4778 21.7999C18.7183 21.7999 17.0309 22.4988 15.7868 23.743C14.5427 24.9871 13.8438 26.6745 13.8438 28.4339C13.8438 28.6853 13.9436 28.9263 14.1213 29.104C14.2991 29.2818 14.5401 29.3816 14.7915 29.3816C15.0428 29.3816 15.2839 29.2818 15.4616 29.104C15.6393 28.9263 15.7392 28.6853 15.7392 28.4339C15.7392 27.1772 16.2384 25.9719 17.1271 25.0832C18.0157 24.1946 19.221 23.6953 20.4778 23.6953C21.7345 23.6953 22.9398 24.1946 23.8284 25.0832C24.7171 25.9719 25.2163 27.1772 25.2163 28.4339C25.2163 28.6853 25.3162 28.9263 25.4939 29.104C25.6716 29.2818 25.9127 29.3816 26.164 29.3816C26.4154 29.3816 26.6564 29.2818 26.8342 29.104C27.0119 28.9263 27.1118 28.6853 27.1118 28.4339C27.1118 26.6745 26.4128 24.9871 25.1687 23.743C23.9246 22.4988 22.2372 21.7999 20.4778 21.7999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_101_1147",
    x: 0.847312,
    y: 0.852051,
    width: 43.9929,
    height: 43.9929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.998219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_1147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_1147",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_101_1147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_1147",
    x1: 38.7548,
    y1: 35.0718,
    x2: 26.6622,
    y2: 0.180225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590159,
    stopColor: "#1A23FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2FFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_1147",
    x1: 5.10198,
    y1: 38.5938,
    x2: 40.5855,
    y2: 3.11028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_1147",
    x1: 24.4598,
    y1: 40.852,
    x2: 42.8267,
    y2: 21.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_1147",
    x1: 0.84375,
    y1: 3.70919,
    x2: 29.7595,
    y2: 47.8715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminKyc);
export default __webpack_public_path__ + "static/media/admin_kyc.c917e8830fa9e5f98e7f05022e894160.svg";
export { ForwardRef as ReactComponent };